import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import styles from '../AppQRCode/styles';

class AuthenticationInfo extends React.PureComponent {
  render() {
    const { t, classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.errorMessage}>{t('welcome.aunthentication_successful')}</div>
      </React.Fragment>
    );
  }
}

AuthenticationInfo.propTypes = {
  t: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AuthenticationInfo));
